import { branch, compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectedPreviewRequirementIdSelector, applicationTabSelected } from "../../../../store/selectors/application";
import RequirementCard from "./RequirementCard";
import fileUploadsEnhancer from "./fileUploadsEnhancer";
import componentErrorBoundary from "../../../../components/enhancers/componentErrorBoundary";
export { buildQuestionsArray } from "./RequirementCard";
var enhancer = compose(componentErrorBoundary, branch(function (_ref) {
  var preview = _ref.preview,
    previewRequirement = _ref.previewRequirement;
  return preview && previewRequirement && typeof previewRequirement === 'function';
}, compose(connect(createStructuredSelector({
  selectedPreviewRequirementId: selectedPreviewRequirementIdSelector
})))), branch(function (_ref2) {
  var requirement = _ref2.requirement,
    preview = _ref2.preview;
  return (requirement.requirement_template_type === 'document' || requirement.requirement_template_type === 'receipt') && !preview;
}, fileUploadsEnhancer));
var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedTab: applicationTabSelected(state),
    application: state.application.application
  };
};
export default enhancer(connect(mapStateToProps)(RequirementCard));